import React from "react";

import AccommodationUnitSelector from "../../../components/Accommodations/AccommodationUnitSelector";
import {useRates} from "../RateContext";
import Card from "@mui/material/Card";
import Paper from "@mui/material/Paper";


const RatePlansToolbar = () => {
    const {accommodations, accUnitSelector} = useRates();

    return <Card sx={{mt: 3, width: "100%"}}>
        <Paper elevation={0} sx={{p: '12px 16px', minHeight: "72px", display: "flex", alignItems: "center", flexDirection: "row"}}>
            <AccommodationUnitSelector accommodationUnits={accommodations.accommodationUnits}
                                       value={accUnitSelector.selectedAccommodationUnit}
                                       onChange={accUnitSelector.handleChange}
                                       isLoading={accommodations.isLoading}
                                       sx={{mr: "auto!important"}}/>
        </Paper>
    </Card>
}

export default RatePlansToolbar;